import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=336bf640&scoped=true"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"
import style0 from "./Card.vue?vue&type=style&index=0&id=336bf640&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336bf640",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('336bf640')) {
      api.createRecord('336bf640', component.options)
    } else {
      api.reload('336bf640', component.options)
    }
    module.hot.accept("./Card.vue?vue&type=template&id=336bf640&scoped=true", function () {
      api.rerender('336bf640', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/UI/Card.vue"
export default component.exports